import './CSS/claim.css'

import AnimatedPage from './animatedPage'

export default function Claim() {

    return (
        <AnimatedPage>
            <div className='aboutPageContainer'>
                <h1>Claim</h1>
                <a className='link' href="https://goerli.etherscan.io/address/0x01B3Be4b23a759D540a38D303d408545CC8eF6C5" target="_blank" rel='noreferrer'>
                    View BBC test contract on etherscan
                </a>
                <a className='link' href="https://goerli.etherscan.io/address/0x779dcE2f2eBD824e8E27b9D94519EA528B3A7377/#code" target="_blank" rel='noreferrer'>
                    View Gnosis safe contract on etherscan
                </a>
                <a className='link' href="https://goerli.etherscan.io/address/0xb64d87b75afe1e4db0d904422a8f0740c1093269#code" target="_blank" rel='noreferrer'>
                    View Equal instant stream contract on etherscan
                </a>
                <a className='link' href="https://goerli.etherscan.io/address/0x4Bc4bbA990Fe31D529D987f7b8CcF79F1626e559#code" target="_blank" rel='noreferrer'>
                    View BTRFLYV2 contract on etherscan
                </a>
                <iframe
                    src="https://v1.flair.dev/public/claim/5/0xb64d87b75afe1e4db0d904422a8f0740c1093269"
                    frameborder="0"
                    width="800px"
                    height="690px"
                    allowtransparency="true"
                    title='Claim'
                />

            </div>
        </AnimatedPage>
    )
}